// JS
import React, { useState } from 'react';
import { renderHTMLspan, useTailwindMediaQuery } from '../shared/utils';

// COMPONENT
const Product = ({
  gaBlockName,
  productID,
  productURL,
  productName,
  productPosition,
  productCategory,
  productBrand,
  productImage,
  productImageAlternate,
  productPrice,
  productPromotionPrice,
  productAspectOptions,
  productObjectOptions,
  button,
  prodWidth = true,
  blackFriday,
  blackFridayBadge,
  badgeClasses
}) => {
  const correctPrice = () => {
    return productPrice !== productPromotionPrice ? (
      <React.Fragment>
        <span className="flex gap-x-2 md:pt-5">
          <span className="line-through">{renderHTMLspan(productPrice)}</span>
          <span className="text-red-600">
            {renderHTMLspan(productPromotionPrice)}
          </span>
        </span>
      </React.Fragment>
    ) : (
      <span className="flex md:pt-5">{renderHTMLspan(productPrice)}</span>
    );
  };

  const [isShown, setIsShown] = useState(false);

  const isMobile = useTailwindMediaQuery('lg');

  return (
    <React.Fragment>
      <a
        href={productURL}
        id={`product-slide-id-${productID}`}
        data-type="collection-prod"
        data-id={productID}
        data-list={gaBlockName}
        data-brand={productBrand}
        data-name={productName}
        data-position={'product-slot-' + productPosition}
        data-price={productPrice}
        data-promotion-price={productPromotionPrice}
        data-quantity={1}
        data-category={productCategory}
        data-currency={'GBP'}
        className={
          'aspect-w-9 aspect-h-8 bg-product' +
          (productAspectOptions?.classes
            ? ' ' + productAspectOptions.classes
            : '')
        }
        onMouseEnter={() => setIsShown(true)}
        onMouseLeave={() => setIsShown(false)}
      >
        {blackFriday && (
          <div className="relative">
            <p
              className={`absolute z-10 top-2.5 left-2.5 px-4 py-3 !text-xs font-semibold tracking-normal bg-red text-white rounded ${badgeClasses}`}
            >
              {blackFridayBadge}
            </p>
          </div>
        )}
        <img
          className="object-contain"
          alt={`${productBrand} ${productName}`}
          src={productImage}
        />

        {!isMobile && isShown && (
          <img
            className={
              'object-fill animate-fade' +
              (productObjectOptions?.classes
                ? ' ' + productObjectOptions.classes
                : '')
            }
            alt={`${productBrand} ${productName}`}
            src={productImageAlternate}
          />
        )}
      </a>

      <div
        id={`product-slide-id-${productID}`}
        className="flex flex-col items-stretch md:items-center w-full justify-between md:flex-row"
      >
        <a
          href={productURL}
          data-type="collection-prod"
          data-id={productID}
          data-list={gaBlockName}
          data-brand={productBrand}
          data-name={productName}
          data-position={'product-slot-' + productPosition}
          data-price={productPrice}
          data-promotion-price={productPromotionPrice}
          data-quantity={1}
          data-category={productCategory}
          data-currency={'GBP'}
          className={`text-left text-xs hover:text-gray-600 lg:pl-3 w-full ${
            !prodWidth ? 'md:max-w-[18rem] lg:max-w-sm' : ''
          }`}
        >
          <h3 className="m-0 mt-4 font-bold leading-6">{productBrand}</h3>
          <p className="flex flex-row justify-between mt-0 mb-4 font-base text-xs uppercase md:flex-col">
            <span className="truncate pr-1.5 md:block md:pr-0">
              {productName}
            </span>
            {correctPrice()}
          </p>
        </a>
        {button}
      </div>
    </React.Fragment>
  );
};

export default Product;
